// extracted by mini-css-extract-plugin
export default {"tasks__container":"Tasks_tasks__container__VEQzc"};